import { SerializedStyles, css } from '@emotion/react';
import { Box, styled } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import MuiMenuItem from '@mui/material/MenuItem/MenuItem';
import { FC } from 'react';
import { MenuItemProps } from '../../../common/model/MenuItemProps';
import { BrandedIcon } from '../../brandedIcon/BrandedIcon';
import { BrandedCheckIcon } from '../../icons/brandedIcons';
import { Body1, Body2, Body3 } from '../../typography/TextStyles';

const StyledMuiMenuItem = styled(MuiMenuItem)`
  ${({ theme }): SerializedStyles => css`
    &.MuiMenuItem-root.Mui-selected {
      background-color: ${theme.palette.background.default};
    }
  `}
`;

export const MenuItem: FC<MenuItemProps> = ({
  title,
  subtitle,
  onClick,
  disabled,
  iconProps,
  sx,
  subtitleLineBreak = 2,
  titleBody = 'body1',
  titleProps,
  subtitleProps,
  selected,
  dataTestId,
  divider,
}) => {
  const BodyStyled = titleBody === 'body1' ? Body1 : Body2;
  const alignItems = subtitle ? (selected !== undefined ? 'center' : 'flex-start') : undefined;
  return (
    <StyledMuiMenuItem
      selected={selected}
      disabled={disabled}
      onClick={onClick}
      sx={{ ...sx, alignItems }}
      data-testid={dataTestId}
      divider={divider}
    >
      {selected !== undefined ? (
        selected ? (
          <ListItemIcon>
            {iconProps ? <BrandedIcon size="large" {...iconProps} /> : <BrandedCheckIcon size="small" />}
          </ListItemIcon>
        ) : (
          <ListItemIcon />
        )
      ) : (
        iconProps && (
          <ListItemIcon>
            <BrandedIcon size="large" {...iconProps} />
          </ListItemIcon>
        )
      )}
      <Box>
        <BodyStyled noWrap {...titleProps}>
          {title}
        </BodyStyled>
        {subtitle && (
          <Body3
            whiteSpace="normal"
            lineBreak={subtitleLineBreak}
            color={disabled ? undefined : 'textSecondary'}
            {...subtitleProps}
          >
            {subtitle}
          </Body3>
        )}
      </Box>
    </StyledMuiMenuItem>
  );
};
